import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { List, X, Phone } from "@phosphor-icons/react";

const navLinks = [
  { label: "Services", to: "/services" },
  { label: "Work", to: "/#portfolio" },
  { label: "About", to: "/#about" },
  { label: "Contact", to: "/#contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  return (
    <header
      data-testid="site-header"
      className={`sticky top-0 z-50 bg-[#F4F4EB] border-b border-[#C4C4B5] transition-shadow ${
        scrolled ? "shadow-[0_2px_0_0_#111110]" : ""
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 h-20 flex items-center justify-between">
        <Link
          to="/"
          data-testid="header-wordmark"
          className="flex items-center gap-3 group"
        >
          <img
            src="/logo.png"
            alt="Schaefer Services logo"
            className="h-12 sm:h-14 w-auto object-contain shrink-0"
          />
          <span className="font-display font-black text-lg sm:text-2xl tracking-tighter uppercase text-[#111110] leading-none">
            Schaefer<span className="text-[#E5231A]">.</span>Services
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-sm font-semibold uppercase tracking-wider text-[#111110] hover:text-[#E5231A] transition-colors"
            >
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a
            href="tel:+13255133501"
            data-testid="header-phone-link"
            className="hidden lg:flex items-center gap-2 text-sm font-semibold text-[#111110] hover:text-[#E5231A]"
          >
            <Phone size={18} weight="fill" />
            (325) 513-3501
          </a>
          <Link
            to="/#contact"
            data-testid="header-quote-cta"
            className="btn-hard bg-[#E5231A] text-[#F4F4EB] font-bold uppercase text-sm px-5 py-3 border border-[#111110]"
          >
            Get a Quote
          </Link>
        </div>

        <button
          type="button"
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
          className="md:hidden p-2 border border-[#111110] bg-[#F4F4EB]"
        >
          {open ? <X size={20} weight="bold" /> : <List size={20} weight="bold" />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden border-t border-[#C4C4B5] bg-[#F4F4EB] px-6 py-6 flex flex-col gap-4"
        >
          {navLinks.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              onClick={() => setOpen(false)}
              data-testid={`mobile-nav-${l.label.toLowerCase()}`}
              className="text-base font-bold uppercase tracking-wider text-[#111110]"
            >
              {l.label}
            </Link>
          ))}
          <a
            href="tel:+13255133501"
            data-testid="mobile-phone-link"
            className="flex items-center gap-2 text-base font-semibold text-[#111110]"
          >
            <Phone size={18} weight="fill" /> (325) 513-3501
          </a>
          <Link
            to="/#contact"
            onClick={() => setOpen(false)}
            data-testid="mobile-quote-cta"
            className="btn-hard bg-[#E5231A] text-[#F4F4EB] font-bold uppercase text-sm px-5 py-3 border border-[#111110] text-center"
          >
            Get a Quote
          </Link>
        </div>
      )}
    </header>
  );
}
